export interface ContactPoint {
	id?: number;
	categoryContactPointId?: number;
	contactValue?: string;
	preferredWayOfContact: boolean;
	personTypeId: number;
	personId: number;
	remark?: string;
}

export interface ContactPointCategory {
	id: number;
	protocol: string;
	remark: string;
	initial: string;
}

export enum ContactPointType {
	PHONE = 1,
	EMAIL = 2,
	PRIVATE_LANDLINE = 3,
	MOBILE_SMS = 5,
	FAX = 6,
	EMAIL_ALTERNATIVE = 7,
	KLIFD_MAILBOX = 8,
	INTERNET = 9,
	FACEBOOK = 12,
	OFFICE_LANDLINE = 13,
	OFFICE_MOBILE = 14,
}

export enum ContactPointKind {
	PHONE = 'phone',
	EMAIL = 'email',
	PRIVATE_LANDLINE = 'private_landline',
	MOBILE_SMS = 'mobile_sms',
	FAX = 'fax',
	EMAIL_ALTERNATIVE = 'email_alternative',
	KLIFD_MAILBOX = 'klifd_mailbox',
	INTERNET = 'internet',
	FACEBOOK = 'facebook',
	OFFICE_LANDLINE = 'office_landline',
	OFFICE_MOBILE = 'office_mobile',
	OTHER = 'other',
}

const CONTACT_POINT_KIND_BY_CATEGORY_ID: Readonly<Record<ContactPointType, ContactPointKind>> = {
	[ContactPointType.PHONE]: ContactPointKind.PHONE,
	[ContactPointType.EMAIL]: ContactPointKind.EMAIL,
	[ContactPointType.PRIVATE_LANDLINE]: ContactPointKind.PRIVATE_LANDLINE,
	[ContactPointType.MOBILE_SMS]: ContactPointKind.MOBILE_SMS,
	[ContactPointType.FAX]: ContactPointKind.FAX,
	[ContactPointType.EMAIL_ALTERNATIVE]: ContactPointKind.EMAIL_ALTERNATIVE,
	[ContactPointType.KLIFD_MAILBOX]: ContactPointKind.KLIFD_MAILBOX,
	[ContactPointType.INTERNET]: ContactPointKind.INTERNET,
	[ContactPointType.FACEBOOK]: ContactPointKind.FACEBOOK,
	[ContactPointType.OFFICE_LANDLINE]: ContactPointKind.OFFICE_LANDLINE,
	[ContactPointType.OFFICE_MOBILE]: ContactPointKind.OFFICE_MOBILE,
};

const PHONE_CATEGORY_IDS: ReadonlySet<number> = new Set([
	ContactPointType.PRIVATE_LANDLINE,
	ContactPointType.OFFICE_LANDLINE,
	ContactPointType.OFFICE_MOBILE,
	ContactPointType.PHONE,
]);

const EMAIL_CATEGORY_IDS: ReadonlySet<number> = new Set([
	ContactPointType.EMAIL,
	ContactPointType.EMAIL_ALTERNATIVE,
	ContactPointType.KLIFD_MAILBOX,
]);

const SMS_CATEGORY_IDS: ReadonlySet<number> = new Set([ContactPointType.MOBILE_SMS]);

const FAX_CATEGORY_IDS: ReadonlySet<number> = new Set([ContactPointType.FAX]);

const WEB_CATEGORY_IDS: ReadonlySet<number> = new Set([ContactPointType.INTERNET, ContactPointType.FACEBOOK]);

export function isPhoneContactPointCategory(categoryContactPointId?: number): boolean {
	return categoryContactPointId != null && PHONE_CATEGORY_IDS.has(categoryContactPointId);
}

export function isEmailContactPointCategory(categoryContactPointId?: number): boolean {
	return categoryContactPointId != null && EMAIL_CATEGORY_IDS.has(categoryContactPointId);
}

export function isSmsContactPointCategory(categoryContactPointId?: number): boolean {
	return categoryContactPointId != null && SMS_CATEGORY_IDS.has(categoryContactPointId);
}

export function isFaxContactPointCategory(categoryContactPointId?: number): boolean {
	return categoryContactPointId != null && FAX_CATEGORY_IDS.has(categoryContactPointId);
}

export function isWebContactPointCategory(categoryContactPointId?: number): boolean {
	return categoryContactPointId != null && WEB_CATEGORY_IDS.has(categoryContactPointId);
}

export function resolveContactPointKind(categoryContactPointId?: number): ContactPointKind {
	if (categoryContactPointId == null) {
		return ContactPointKind.OTHER;
	}

	return CONTACT_POINT_KIND_BY_CATEGORY_ID[categoryContactPointId as ContactPointType] ?? ContactPointKind.OTHER;
}
